export default __webpack_public_path__ + "static/media/box.162dba05.png";